<template>
  <div id="dashboard-page">
    <div class="dashboard-page-wrapper" :class="{ 'hidden': showDownloadPopup }">
      <h1>Data Centre</h1>
      <dashboard-card-container
        v-model="companySections"
        @download="getDownloadAllFile"
      />
    </div>
    <download-all
        v-if="showDownloadPopup"
        :downloading="downloadingAll"
        :success="downloadAllSuccess"
        :download-file="downloadFile"
        @downloadAll="downloadAll"
        @closeDownloadAllModal="closeDownloadAllModal"
    />
  </div>
</template>

<script>
import DashboardCardContainer from './DashboardCardContainer.vue'
import { formMap } from './SectionsConfig'
import DownloadAll from './DownloadAll';
import FileDownloadMixin from "../../../components/mixins/FileDownloadMixin";

export default {
  name: "DashboardGrid",
  components: {
    DashboardCardContainer,
    DownloadAll,
  },
  mixins: [FileDownloadMixin],
  data() {
    return {
      companySections: formMap(),
      showDownloadPopup: false,
      downloadingAll: false,
      downloadAllSuccess: false,
      downloadFile: {},
    };
  },
  methods: {
    closeDownloadAllModal() {
      this.showDownloadPopup = false;
      this.downloadingAll = false;
      this.downloadAllSuccess = false;
      this.downloadFile = {};
    },
  },
}
</script>
